import { getItem as secureGetItem } from '@/services/secureStorage';

const storedUser =
  typeof window !== 'undefined' && secureGetItem('user')
    ? JSON.parse(secureGetItem('user') as string)
    : null;

const state = {
  // Initialise user from secureStorage (cookie/localStorage abstraction). This
  // guarantees that on a hard-refresh we still have the user id available for
  // API calls such as `fetchStudentById`.
  user: storedUser,
  programDoc: null,
  error: false,
  userType: '',
  isOpenDialog: false,
  profileComplete:
    typeof window !== 'undefined' && secureGetItem('profileComplete')
      ? JSON.parse(secureGetItem('profileComplete') as string)
      : false
};
export default state;
